import { CartId } from 'lib/types'
import { RootState } from 'lib/core/data/reducer'

export const getCouponRemove = (cartId: CartId) => (state: RootState) => {
  return state.quote.couponRemove[cartId ?? ''] ?? {}
}
